export const TEXT_COLOR_PRESETS = [
  { label: 'Default', value: '' },
  { label: 'Dark', value: '#172b4d' },
  { label: 'Gray', value: '#5e6c84' },
  { label: 'Blue', value: '#0052cc' },
  { label: 'Green', value: '#00875a' },
  { label: 'Red', value: '#de350b' },
  { label: 'Purple', value: '#6554c0' },
  { label: 'Orange', value: '#ff991f' },
];

export const HIGHLIGHT_PRESETS = [
  { label: 'None', value: '' },
  { label: 'Yellow', value: '#fff0b3' },
  { label: 'Green', value: '#e3fcef' },
  { label: 'Blue', value: '#deebff' },
  { label: 'Red', value: '#ffebe6' },
  { label: 'Gray', value: '#ebecf0' },
];

export const EMOJI_PRESETS = [
  '✅', '⭐', '📦', '🔒', '📷', '💡', '⚠️', '✔️',
  '❌', '🛒', '📞', '🏠', '🔧', '⚡', '🎯', '📝',
  '👍', '👎', '🔥', '💯', '📌', '🚀', '❤️', '🙂',
];

export const promptForLink = (editor) => {
  if (!editor || editor.isDestroyed) return;
  const previous = editor.getAttributes('link').href || '';
  const url = window.prompt('Link URL', previous);
  if (url === null) return;
  const trimmed = String(url).trim();
  if (!trimmed) {
    editor.chain().focus().extendMarkRange('link').unsetLink().run();
    return;
  }
  editor.chain().focus().extendMarkRange('link').setLink({ href: trimmed }).run();
};

export const getBlockStyleValue = (editor) => {
  if (!editor) return 'paragraph';
  if (editor.isActive('heading', { level: 2 })) return 'h2';
  if (editor.isActive('heading', { level: 3 })) return 'h3';
  if (editor.isActive('heading', { level: 4 })) return 'h4';
  return 'paragraph';
};

export const applyBlockStyle = (editor, value) => {
  if (!editor) return;
  const chain = editor.chain().focus();
  if (value === 'h2') chain.toggleHeading({ level: 2 }).run();
  else if (value === 'h3') chain.toggleHeading({ level: 3 }).run();
  else if (value === 'h4') chain.toggleHeading({ level: 4 }).run();
  else chain.setParagraph().run();
};
